import React, { Component } from 'react';
import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import { MyContext, MyGlobal, MyHeading, MyAlert } from '../../GlobalContext';


export class Recount_Location extends Component {
    static displayName = Recount_Location.name;

    constructor(props) {
        super(props);
        this.state = {
            selectedStocktake: "",
            loading: false,
            alertMessage: "",
            uncountedRows: [],
            sortOrder: "true",
            useColumnLocation: false,
            columnLocation: 0,
            rowLocation:""
        };
        this.history = props.history;
    }

    componentDidMount() {
        if (!MyGlobal.selected_stocktake) {
            this.setState({ alertMessage: "Please select a Stocktake" });
            return;
        }

        var selectedStocktakeParsedData = JSON.parse(MyGlobal.selected_stocktake);
        if (selectedStocktakeParsedData) {
            this.state.selectedStocktake = selectedStocktakeParsedData;
        }

        if (!this.state.selectedStocktake.stocktakeId || this.state.selectedStocktake.stocktakeId === "") {
            this.setState({ alertMessage: "Please select a Stocktake" });
            return;
        }
        this.getUncountedRows();
    }
    goto(page) {
        this.history.push(page);
    }


    async getUncountedRows() {
        this.state.loading = true;

        fetch(`api/Stocktake/GetUncountedRecountRows?stocktakeId=${this.state.selectedStocktake.stocktakeId}`)
            .then(async response => {

                this.state.loading = false;
                // check for error response
                if (!response.ok) {
                    const errorText = await response.text();
                    this.setState({ uncountedRows: [], alertMessage: errorText });
                }
                else {
                    const isJson = response.headers.get('content-type')?.includes('application/json');
                    const apiResponse = isJson ? await response.json() : null;


                    if (apiResponse) {
                        const data = apiResponse.data;
                        if (apiResponse.success) {
                            this.setState({ uncountedRows: data, alertMessage: "" });
                        }
                        else {
                            this.setState({ alertMessage: "Failed to load rows!!  " + apiResponse.errorMessage });
                        }
                    }
                    else {
                        this.setState({ alertMessage: "Failed to load rows!!" });
                    }
                }

            })
            .catch(error => {
                this.setState({ uncountedRows: [], alertMessage: error });
            });
    }

    selectUncountedRow(selectedRow) {


        MyGlobal.stocktake_loc_details = JSON.stringify({
            sortOrder: this.state.sortOrder,
            useColumnLocation: this.state.useColumnLocation,
            columnLocation: this.state.columnLocation,
            rowLocation: selectedRow.locationRow
        });


        this.goto('Recount_ConfirmLocation');
    }

    renderUncountedRows() {

        return (
            <div>
                <table className='table table-striped' aria-labelledby="tabelLabel">
                    <thead style={{ position: 'sticky', top: -2, background: 'white' }}>
                        <tr>
                            <th className="col-sm-4">
                                <label>Location Row</label>
                            </th>
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.uncountedRows
                            .map(row =>
                                <tr key={row.locationRow} onClick={() => { this.selectUncountedRow(row) }}>
                                    <td>{row.locationRow}</td>
                                </tr>
                            )}
                    </tbody>
                </table>
            </div>
        );
    }
    render() {

        let uncountedRowsHtml = this.state.loading
            ? <p><em>Loading...</em></p>
            : this.renderUncountedRows();

        let alertMessage = this.state.alertMessage;
        alertMessage = alertMessage != "" ? <MyAlert variant="danger">{alertMessage}</MyAlert> : "";

        return (
            <div>
                <Container>
                    <Row className="mb-3">
                        <Col xs={9}><h5>Recount - Select a row</h5></Col>
                        <Col xs={3}><button type="button" className="btn btn-success col-12 mb-2" onClick={() => { this.goto('../StocktakeTasks'); }} >
                            Back
                        </button></Col>
                    </Row>
                    <Row className="mb-3">
                        <Col>{alertMessage}</Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={5}>
                            <label> Count Sort Order :</label>
                        </Col>
                        <Col xs={7}>
                            <select className="form-select form-control" aria-label=".form-select-lg example" onChange={(e) => {
                                this.setState({ sortOrder: e.target.value });
                            }} >
                                <option key="0" value="true" defaultValue >Front to Back (A-Z)</option>
                                <option key="1" value="false" >Back to Front (Z-A)</option>
                            </select>
                        </Col>
                    </Row>
                    <Row className="mb-3">
                        <Col xs={5}>
                            <label> Start at Column :</label>
                        </Col>
                        <Col xs={7}>
                            <input className="form-control" type="number" 
                                onChange={(e) => {
                                    this.setState({ columnLocation: e.target.value, useColumnLocation: true });
                                }} >
                            </input>

                         
                        </Col>
                    </Row>
                    <Row>
                        <Col>
                            <div className="tableHolder hm-50vh mb-3">
                                {uncountedRowsHtml}
                            </div>
                        </Col>
                    </Row>
                </Container>
            </div>

        );
    }


}
